<template>
  <el-form
    ref="form"
    :model="list"
    label-width="80px"
    style="padding-left: 170px"
  >
    <el-form-item label="专题名称:">
      <el-input
        v-model="list.typeName"
        size="small"
        style="width: 320px"
        maxlength="50"
        show-word-limit
      ></el-input>
    </el-form-item>
    <el-form-item label="允许下载:">
      <el-switch
        v-model="list.downloadStatus"
        :active-value="1"
        :inactive-value="0"
      >
      </el-switch>
    </el-form-item>
    <el-form-item label="专题封面:">
      <el-upload
        class="avatar-uploader"
        action="fakeaction"
        :http-request="uploadSectionFile"
        :show-file-list="false"
      >
        <img
          v-if="list.typeImage"
          :src="uploadUrl + list.typeImage"
          class="avatar"
          style="width: 178px; height: 178px"
        />
        <i v-else class="el-icon-plus avatar-uploader-icon"></i>
      </el-upload>
      <span style="color: #999"
        >支持 jpg,png,gif 格式的图片，图片限制大小 10MB ，推荐图片尺寸为
        270*150。</span
      >
    </el-form-item>
    <div style="width: 880px; text-align: center; padding-top: 40px">
      <template v-if="list.new1">
        <el-button @click="$router.push({ name: 'special' })">取消</el-button>
        <el-button type="primary" @click="listSave(false)">立即创建</el-button>
        <el-button type="primary" @click="listSave()"
          >继续添加专题资源</el-button
        ></template
      >
      <template v-else>
        <el-button @click="noDialog">取消</el-button>
        <el-button type="primary" @click="edit()">修改</el-button>
      </template>
    </div>
  </el-form>
</template>

<script>
import upload from "../../mixins/upload";
export default {
  data() {
    return {
      uploadUrl: "",
    };
  },
  mixins: [upload],
  props: {
    value: {
      default: "",
    },
    list: {
      default: () => {
        return {
          typeName: "",
          typeImage: "",
          new1: true,
          id: "",
          downloadStatus: 1,
        };
      },
    },
  },
  mounted() {
    console.log(this.list)
    this.uploadUrl = window.sessionStorage.getItem("uploadUrl");
  },
  methods: {
    noDialog() {
      this.$emit("noDialog");
    },
    async uploadSectionFile(params) {
      let file = await this.upload(params);
      this.list.typeImage = file.url;
    },
    edit() {
      if (this.list.typeName == "") {
        this.$message.warning("请输入专题名称");
        return false;
      }
      if (this.list.typeImage == "") {
        this.$message.warning("请上传专题封面图片");
        return false;
      }
      this.$ajax.post("/server/thematic/type/update", this.list).then((res) => {
        this.noDialog();
      });
    },
    listSave(v = true) {
      if (this.list.typeName == "") {
        this.$message.warning("请输入专题名称");
        return false;
      }
      if (this.list.typeImage == "") {
        this.$message.warning("请上传专题封面图片");
        return false;
      }

      this.$ajax.post("/server/thematic/type/save", this.list).then((res) => {
        this.list.typeName == "";
        this.list.typeImage == "";
        if (v) {
          this.$emit("getId", res.id);
          this.$emit("input", 2);
        } else {
          this.$router.push({ name: "special" });
        }
      });
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/page/special/attribute.vue